import {createStore, applyMiddleware} from 'redux'
import thunk from "redux-thunk";
import logger from 'redux-logger'
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';

import rootReducer from "./rootReducer";

const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
)

export default store